import './index.css';
import './indexv11.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import PortalShell from './app/PortalShell';
ReactDOM.render(React.createElement(Router, null,
    React.createElement(PortalShell, null)), document.getElementById('root'));
